import React from 'react';
import {AlertProvider} from '@lib/hooks';
import CopyToClipboardMenuItem from '@lib/ui/v1/CopyToClipboardMenuItem';

const CopySheetUrlMenuItemWrapper = ({publicUrl}) => {
  return (
    <AlertProvider>
      <CopyToClipboardMenuItem
        value={publicUrl}
        label="Copy to Clipboard"
        tip="Copy this sheet's public URL to your computer's clipboard"
      />
    </AlertProvider>
  );
}

export default CopySheetUrlMenuItemWrapper;
